var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { lg: "3", cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text" },
                            [_vm._v("ID")]
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              _vm._s(
                                (
                                  (
                                    _vm.feedingProgramData.id || ""
                                  ).toString() || ""
                                ).padStart(6, "0")
                              )
                            )
                          ]),
                          _c("v-divider")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { lg: "3", cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text" },
                            [_vm._v("Stock")]
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              _vm._s(
                                (_vm.feedingProgramData.stock || {})
                                  .description || null
                              )
                            )
                          ]),
                          _c("v-divider")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { lg: "3", cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text" },
                            [_vm._v("Stock Category")]
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              _vm._s(
                                (
                                  (_vm.feedingProgramData.stock || {})
                                    .category || {}
                                ).name || null
                              )
                            )
                          ]),
                          _c("v-divider")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { lg: "3", cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text" },
                            [_vm._v("Type")]
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              _vm._s(
                                (_vm.feedingProgramData.category || {})
                                  .description || null
                              )
                            )
                          ]),
                          _c("v-divider")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { lg: "3", cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text" },
                            [_vm._v("Day Range")]
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              _vm._s(_vm.feedingProgramData.day_start || null) +
                                " - " +
                                _vm._s(_vm.feedingProgramData.day_end || null)
                            )
                          ]),
                          _c("v-divider")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { lg: "3", cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text" },
                            [_vm._v("Body Weight")]
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              _vm._s(
                                (
                                  _vm.feedingProgramData.body_weight || 0
                                ).unitFormat("kilogram")
                              )
                            )
                          ]),
                          _c("v-divider")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { lg: "3", cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text" },
                            [_vm._v("Expected Weight")]
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              _vm._s(
                                (
                                  _vm.feedingProgramData.expected_weight || 0
                                ).unitFormat("kilogram")
                              )
                            )
                          ]),
                          _c("v-divider")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            color: _vm.editFeedingProgramDetailMode
                              ? "yellow darken-3"
                              : "primary",
                            dense: "",
                            elevation: "0",
                            dark: ""
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                !_vm.editFeedingProgramDetailMode
                                  ? "New"
                                  : "Edit"
                              )
                            )
                          ])
                        ]
                      ),
                      _c("create-feeding-program-detail", {
                        attrs: {
                          "last-day": _vm.feedingProgramDetailLastday,
                          "default-field-values": _vm.feedingProgramDetailData
                        },
                        on: {
                          "update:defaultFieldValues": function($event) {
                            _vm.feedingProgramDetailData = $event
                          },
                          "update:default-field-values": function($event) {
                            _vm.feedingProgramDetailData = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            color: "primary",
                            dense: "",
                            elevation: "0",
                            dark: ""
                          }
                        },
                        [_c("span", [_vm._v("List")])]
                      ),
                      _c("table-feeding-program-detail", {
                        on: {
                          edit: item => {
                            _vm.feedingProgramDetailData = item
                          }
                        },
                        model: {
                          value: _vm.feedingProgramDetailLastday,
                          callback: function($$v) {
                            _vm.feedingProgramDetailLastday = $$v
                          },
                          expression: "feedingProgramDetailLastday"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }